// EXTERNAL DEPENDENCIES
import React from 'react'

// COMPONENTS
import { LoadingSpinner } from '@paypalcorp/pp-react'

// CONSTANTS
import { LOADING_CONTAINER_TEST_ID } from '../../../../constants/test-ids'

// STYLES
import { LoadingContainer } from './styles'

/**
 * Displays a loading spinner that spans the entire screen
 */
export default function CenteredLoadingSpinner({
  height = '60vh',
}: {
  height?: string
}) {
  return (
    <LoadingContainer
      style={{ height }}
      data-testid={LOADING_CONTAINER_TEST_ID}
    >
      <LoadingSpinner size='lg' />
    </LoadingContainer>
  )
}
